import { API_ROOT } from '../../config/config'
import { doDeleteData, doGet, doPost, doPut } from './utils'

// const API_ROOT = 'http://localhost:9001/api'

export const managementSearchProject = (projectName, projectCode, pageNumber, pageSize, type) => {
  const url = `${API_ROOT}/portal/management/project/search/${pageNumber}/${pageSize}?projectname=${
    projectName || ''
  }&projectCode=${projectCode || ''}&type=${type || ''}`
  return doGet(url)
}

export const getManagementProjectStatusPage = () => {
  const url = `${API_ROOT}/portal/management/project/status/page`
  return doGet(url)
}

export const getManagementProjectStatus = (projectVersionId) => {
  const url = `${API_ROOT}/portal/management/project/status/form/${projectVersionId}`
  return doGet(url)
}

export const updateManagementProjectStatus = (projectVersionId, request) => {
  const url = `${API_ROOT}/portal/management/project/status/form/${projectVersionId}`
  return doPut(url, request)
}

export const getManagementProjectCoordinatorPage = () => {
  const url = `${API_ROOT}/portal/management/project/coordinator/page`
  return doGet(url)
}

export const getManagementProjectCoordinator = (projectVersionId) => {
  const url = `${API_ROOT}/portal/management/project/coordinator/form/${projectVersionId}`
  return doGet(url)
}

export const updateManagementProjectCoordinator = (projectVersionId, request) => {
  const url = `${API_ROOT}/portal/management/project/coordinator/form/${projectVersionId}`
  return doPut(url, request)
}

export const getManagementRoundSchema = () => {
  const url = `${API_ROOT}/portal/management/round/schema`
  return doGet(url)
}

export const saveManagementRound = (request) => {
  const url = `${API_ROOT}/portal/management/round/save`
  return doPost(url, request)
}

export const updateManagementRound = (id, request) => {
  const url = `${API_ROOT}/portal/management/round/save/${id}`
  return doPut(url, request)
}

export const deleteManagementRound = (id) => {
  const url = `${API_ROOT}/portal/management/round/${id}`
  return doDeleteData(url)
}

export const getManagementRound = (id) => {
  const url = `${API_ROOT}/portal/management/round/${id}`
  return doGet(url)
}

export const searchManagementRound = (request) => {
  const url = `${API_ROOT}/portal/management/round/search`
  return doPost(url, request)
}

//จัดการสิทธิ์
export const getManagePermissions = () => {
  const url = `${API_ROOT}/portal/management/permission`
  return doGet(url)
}

//สิทธิ์เมนู
export const getMainMenuPermission = () => {
  const url = `${API_ROOT}/portal/management/main-menu-permission`
  return doGet(url)
}

export const saveMainMenuPermission = (request) => {
  const url = `${API_ROOT}/portal/management/main-menu-permission`
  return doPost(url, request)
}

//สิทธิ์การดำเนินการ
export const getProcessPermission = () => {
  const url = `${API_ROOT}/portal/management/process-permission`
  return doGet(url)
}

export const saveProcessPermission = (request) => {
  const url = `${API_ROOT}/portal/management/process-permission`
  return doPost(url, request)
}

//จัดการวันหยุด
export const getHoliday = (year) => {
  const url = `${API_ROOT}/portal/master/holiday/get?year=${year || 0}`
  return doGet(url)
}

export const saveHoliday = (request) => {
  const url = `${API_ROOT}/portal/master/holiday/save`
  return doPost(url, request)
}

export const deleteHoliday = (id, year) => {
  const url = `${API_ROOT}/portal/master/holiday/${id}?year=${year || 0}`
  return doDeleteData(url)
}
